import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import AgentSignature from '@/components/Common/AgentSignature';
import ParsedDayScheduleCalendar from '@/components/Common/ParsedDayScheduleCalendar';
import { hDeepCopy } from '@/utils/helpers';
import ConnectionType from './ConnectionType';

// @vue/component
export default {
  name: 'AgentsListItem',

  components: {
    ShPopConfirm,
    AgentSignature,
    ParsedDayScheduleCalendar,
    ConnectionType,
  },

  props: {
    agent: {
      type: Object,
      default: () => ({}),
    },
    connectionTypeList: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isWaitingForChangeAgentLoggedStatus: false,
      activeTypes: [],
      agentCopy: null,
      isWatingForPernamentLoggedChange: false,
      isWatingForIsRecordedChange: false,
    };
  },

  computed: {
    isLogged() {
      return this.agent.is_logged;
    },
    activeTypesList() {
      return [{ name: 'dialout', status: this.agent.dialout },
        { name: 'massdial4call', status: this.agent.massdial4call },
        { name: 'callweb', status: this.agent.callweb },
        { name: 'chat', status: this.agent.chat_members }];
    },
    type() {
      const typeMap = {
        agent: 'Agent',
        unit: 'Placówka',
      };

      return typeMap[this.agent.type] || '---';
    },
    agentGroupName() {
      return this.$store.getters['client/project/agentsGroups/list'].records.find(
        group => group.id === this.agent.group_agents,
      ) ? `region: ${(this.$store.getters['client/project/agentsGroups/list'].records).find(
          group => group.id === this.agent.group_agents,
        ).name}` : 'brak regionu';
    },
  },

  created() {
    this.agentCopy = hDeepCopy(this.agent);
  },

  methods: {
    handleEditAgent() {
      this.$EventBus.$emit('SHOW_AGENT_DETAILS', this.agent.uuid);
    },
    editWorkHours() {
      this.$emit('openWorkHoursEditForm', this.agent);
    },
    async handleDeleteAgent() {
      await this.$store.dispatch('client/project/agents/removeAgent', { agent: this.agent.uuid });
      this.$emit('refreshList');
      this.$message({
        message: `Pomyślnie usunięto Agenta / Placówkę: ${this.agent.name}`,
        type: 'success',
      });
    },
    async toggleAgentLoggedStatus() {
      this.isWaitingForChangeAgentLoggedStatus = true;
      await this.$store.dispatch('client/project/agents/updateAgentStatus', {
        newStatus: !this.agent.is_logged,
        agent: this.agent.uuid,
        actionId: 1,
      });
      this.$store.commit('client/project/agents/CHANGE_RECORD_STATUS', this.agent);
      this.isWaitingForChangeAgentLoggedStatus = false;
    },
  },
};
